<div [ngClass]="{'active': scrolled}" (click)="scrollTo()" class="back-to-top">
  <img src="/assets/image/move_to_top_20.png" class="" width="55px">
</div>
